import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteCargoCliente, getCargoClienteById } from '../../core/_request'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { CargoClienteModal } from '../../components/modal/CargoClienteModal'
import { CargoAsoList } from '../../core/_models'

type Props = {
  cargo: CargoAsoList
}

export const CargoActionsCell: FC<Props> = ({ cargo }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = cargo.nome || 'Cargo'

  const openEditModal = () => {
    showModal({
      title: 'Cargo',
      content: <CargoClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        cargo: () => getCargoClienteById(cargo.id),
      },
    })
  }

  // Excluir é destrutivo: confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir cargo?',
      text: `${nome} será excluído. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteCargoCliente(cargo.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
